import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";
import * as actions from '../Actions';
import ChildListOverlay from '../ChildListOverlay'

export default (props) => {
  // //console.log(props);
  var data = props.data;
  var eleRef = props.eleRef;
  // //console.log("eleRef slider right------",eleRef)
  var selectedChild=eleRef.state.selectedChild;
  console.log("selectedChild in sliderBabyRightSite===========",selectedChild);
  //var userAryConceive=eleRef.state.childProfileData.userArr.isTryingToConceive;
  ////console.log("userAryConceive====",userAryConceive)
  // //console.log("props data ::::::",data)
  let isTryingToConceive;
  let childData=[];
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);


  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: true,
      slidesPerView:1,
      spaceBetween: 0,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => {
        updateCurrentIndex(swiper.realIndex); 
        // //console.log("currentIndex --",swiper.realIndex);
        // //console.log("data[0].childArr --- ",data.childArr[swiper.realIndex])
        props.eleRef.getLatestFeedByChild(data.childArr[swiper.realIndex]);
        });
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    
    
 <div>
{ selectedChild && Object.keys(selectedChild).length > 0 ?


    <div>
       {!selectedChild.isExpecting && selectedChild.childId!="" &&
<div>
  <div className="baby-slider-overlay-view">
    <div className="baby-slide-all-common baby_bg_image_background"> 
      <div className="right_sidebar_ps_sidebar_ps">
         <div className="right_sidebar_dates_weight ">
              <div className="right_sidebar_ps_profile">
             
                  <div className="right_sidebar_ps_profile-images">
                  {selectedChild.childPhoto == "" ?
                    <div>

                  {selectedChild.age?.year == 0?
                                                   (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-Infant.webp" alt={selectedChild.childName} title={selectedChild.childName} onClick={()=>actions.openprofilePopup()} role="button" tabIndex={0} aria-label="select child" data-popup="select profile" onKeyDown={(e)=>{if(e.key==='Enter'){actions.openprofilePopup(); 
                                                   setTimeout(() => {
                  const popup = document.querySelector('.select_child_popup_feeds [tabindex]');
                  if (popup) popup.focus();
                }, 0);}}}/>):
                  selectedChild.age?.year < 2 ?
                                                        (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02-Baby.webp" alt={selectedChild.childName} title={selectedChild.childName} onClick={()=>actions.openprofilePopup()} role="button" tabIndex={0} data-popup="select profile" aria-label="select child" onKeyDown={(e)=>{if(e.key==='Enter'){actions.openprofilePopup(); setTimeout(() => {
                                                          const popup = document.querySelector('.select_child_popup_feeds [tabindex]');
                                                          if (popup) popup.focus();
                                                        }, 0);}}}/>):
                                                        selectedChild.age?.year < 4 ?
                                                        (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03-Toddler.webp" alt={selectedChild.childName} title={selectedChild.childName} onClick={()=>actions.openprofilePopup()} role="button" tabIndex={0} data-popup="select profile" aria-label="select child" onKeyDown={(e)=>{if(e.key==='Enter'){actions.openprofilePopup(); setTimeout(() => {
                                                          const popup = document.querySelector('.select_child_popup_feeds [tabindex]');
                                                          if (popup) popup.focus();
                                                        }, 0);}}}/>):
                                                        (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05-Big Kids.webp" alt={selectedChild.childName} title={selectedChild.childName} onClick={()=>actions.openprofilePopup()} role="button" tabIndex={0} data-popup="select profile" aria-label="select child" onKeyDown={(e)=>{if(e.key==='Enter'){actions.openprofilePopup(); setTimeout(() => {
                                                          const popup = document.querySelector('.select_child_popup_feeds [tabindex]');
                                                          if (popup) popup.focus();
                                                        }, 0);}}}/>)}
                                        </div>                :
(<img src={selectedChild.childPhoto} alt={selectedChild.childName} title={selectedChild.childName} onClick={()=>actions.openprofilePopup()} role="button" tabIndex={0} data-popup="select profile" aria-label="select child" onKeyDown={(e)=>{if(e.key==='Enter'){actions.openprofilePopup(); setTimeout(() => {
                                                          const popup = document.querySelector('.select_child_popup_feeds [tabindex]');
                                                          if (popup) popup.focus();
                                                        }, 0);}}}/>)   }
                  </div>
                  <span className="icon" data-icon-font="H" onClick={()=>actions.openprofilePopup()}></span>
              </div>
              <div className="baby_name_title_disc B20_21">
              <em className="useName">{selectedChild.childName?selectedChild.childName:'Your baby '}</em> is <span> {selectedChild.age?.year?selectedChild.age?.year:''} </span>{selectedChild.age?.year?(selectedChild.age?.year>1?' Years':'Year'):''} {selectedChild.age?.year && selectedChild.age?.month?" & ":''} <span> {selectedChild.age?.month?selectedChild.age?.month:''} </span> {selectedChild.age?.month?(selectedChild.age?.month>1?' months':'month'):''} {(selectedChild.age?.month && !selectedChild.age?.year && selectedChild.age?.days)||((!selectedChild.age?.year && selectedChild.age?.days)||(!selectedChild.age?.month && selectedChild.age?.days))?'&':''}  <span>{((!selectedChild.age?.year && selectedChild.age?.days)||(!selectedChild.age?.month && selectedChild.age?.days))?selectedChild.age?.days:''}</span> {((!selectedChild.age?.year && selectedChild.age?.days)||(!selectedChild.age?.month && selectedChild.age?.days))?(selectedChild.age?.days>1?' Days':'Day'):''} old  
              </div>
              <div className="right_sidebar_ps_baby_weight">
                 <div className="right_sidebar_ps_details-content">
                   <div className="baby_weight_details-content">
                      <div className="text_content_details">
                         <div className="text_ideal_details M15_75"> Ideal Weight </div>
                         <div className="dis_ideal_details"> {selectedChild.weight?selectedChild.weight:'0'} kg </div>
                      </div>
                   </div>
                   <div className="baby_weight_details-content baby_before_details">
                     <div className="text_content_details">
                         <div className="text_ideal_details M15_75"> Ideal height </div>
                         <div className="dis_ideal_details">{selectedChild.height?selectedChild.height:'0'} Cm </div>
                      </div>
                   </div>
                </div>
              </div>
          </div> 
    </div>
    </div>
  </div>
  </div> 
 
}



{selectedChild.isExpecting==1  && !selectedChild.isTryingToConceive &&
<div className="baby-slider-overlay-view">
    <div className="baby-slide-all-common baby_bg_image_background"> 
      <div className="right_sidebar_ps_sidebar_ps">
         <div className="right_sidebar_dates_weight ">
              <div className="right_sidebar_ps_profile">
                  <div className="right_sidebar_ps_profile-images baby_circle_profile21">
                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp" alt={selectedChild.childName?selectedChild.childName:global.userAry['userName']} title={selectedChild.childName?selectedChild.childName:global.userAry['userName']} onClick={()=>actions.openprofilePopup()} role="button" tabIndex={0} data-popup="select profile" aria-label="select profile" onKeyDown={(e)=>{if(e.key==='Enter'){actions.openprofilePopup(); setTimeout(() => {
                      const popup = document.querySelector('.select_child_popup_feeds [tabindex]');
                      if (popup) popup.focus();
                    }, 0);}}}/>
                  </div>
                    <span className="icon gtm-baby-swipe" data-icon-font="H" onClick={()=>actions.openprofilePopup()}></span>
              </div>
              <div className="baby_name_title_disc  baby_name_desktop_after B20_21">
              <em className="useName">{selectedChild.childName?selectedChild.childName:global.userAry['userName']}</em> is <span>{selectedChild.currentWeek?selectedChild.currentWeek:''} </span> {selectedChild.currentWeek?'weeks &':''}<span> {selectedChild.age?.days?selectedChild.age?.days:''} </span> {selectedChild.age?.days?'Days ':''}Pregnant
              </div>

              <div className="baby_in_comparision_to">
              
              {eleRef.state.BabysizecomparisonSlider && eleRef.state.BabysizecomparisonSlider[0] && eleRef.state.BabysizecomparisonSlider[0].data && eleRef.state.BabysizecomparisonSlider[0].data[0] && eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray && 
              <div>

              <div className="baby_in_comparision_heading M14_42">
                  {eleRef.state.BabysizecomparisonSlider[0].data[0].descriptionText}
              </div>

              <div className="baby_in_comparision_mainview">
              
                 
                <div className="comparision_mainview_div"> 
                    <div className="comparision_mainview_div_pic">
                    <img src={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.animalUrl} onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}} alt={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.animalName} title={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.animalName}/>
                    <div className="bottom_comparision_mainview M12_white">
                       {eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.animalName}
                    </div>
                    </div>
                 </div>
                 <div className="comparision_mainview_div"> 
                    <div className="comparision_mainview_div_pic">
                    <img src={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.fruitUrl} onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}} alt={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.fruitName} title={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.fruitName}/>
                    <div className="bottom_comparision_mainview M12_white">
                       {eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.fruitName}
                    </div>
                    </div>
                 </div>
                 <div className="comparision_mainview_div"> 
                    <div className="comparision_mainview_div_pic">
                    <img src={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.sweetsUrl} onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}} alt={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.sweetsName} title={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.sweetsName}/>
                    <div className="bottom_comparision_mainview M12_white">
                       {eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.sweetsName}
                    </div>
                    </div>
                 </div>
              </div>
            </div>
              }
              </div>

          </div> 
    </div>
    </div>
  </div>

}
{
  selectedChild.isTryingToConceive > 0 && selectedChild.childId=="" &&
  <div>
  <div className="baby-slider-overlay-view ttcWrapper">
    <div className="baby-slide-all-common baby_bg_image_background"> 
      <div className="right_sidebar_ps_sidebar_ps">
         <div className="right_sidebar_dates_weight ">
              <div className="right_sidebar_ps_profile">
                  <div className="right_sidebar_ps_profile-images">
                  <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07-Trying-to-concieve.webp" alt="Trying to Conceive" title="Trying to Conceive" onClick={()=>actions.openprofilePopup()} role="button" tabIndex={0} data-popup="select profile" aria-label="select profile" onKeyDown={(e)=>{if(e.key==='Enter'){actions.openprofilePopup(); setTimeout(() => {
                      const popup = document.querySelector('.select_child_popup_feeds [tabindex]');
                      if (popup) popup.focus(); 
                    }, 0);}}}/>
                   </div>
                  <span className="icon" data-icon-font="H" onClick={()=>actions.openprofilePopup()}></span>
              </div>
              <div className="baby_name_title_disc B20_21">
              <em className="useName ttcName">{global.userAry['userName']?global.userAry['userName']:''}</em> <span className="ttc">Is Trying To Conceive</span>   
              </div>
              
          </div> 
    </div>
    </div>
  </div>
  </div> 
}
    </div>
   

    :
    
          <div>
      <div className="baby-slider-overlay-view">
        <div className="baby-slide-all-common baby_bg_image_background"> 
        {/* <div className="baby-section-overylay">
          <div className="baby_name_title_disc B18_21">
          {global.userAry['userName']?global.userAry['userName']:''} 
          </div>
           <div className="baby_details_dates_weight ">
            <div className="left_baby_weight">
              <div className="left_baby_weight_details-content">
                <div className="baby_weight_details-content">
                  <div className="text_content_details">
                    <div className="text_ideal_details"> Ideal height </div>
                    <div className="dis_ideal_details"> 79.6 - 91.5 cm </div>
                  </div>
                </div>
                <div className="baby_weight_details-content baby_before_details">
                  <div className="text_content_details">
                    <div className="text_ideal_details"> Ideal Weight </div>
                    <div className="dis_ideal_details">  9 - 14.3 kg </div>
                    </div>
                    </div>
              </div>
            </div>
            <div className="right_baby_profile">
              <div className="baby_profile-images">
              <img src={global.userAry['userPhoto']?global.userAry['userPhoto']:"../media/default-img.png"} alt="logo"/> 
                  </div>
                  </div>

          </div>
        </div>  */} 
          <div className="right_sidebar_ps_sidebar_ps">
             <div className="right_sidebar_dates_weight ">
                  <div className="right_sidebar_ps_profile">
                      <div className="right_sidebar_ps_profile-images">
                      <a href="https://parenting.firstcry.com/my-account/myprofile" role="button" tabIndex={0} aria-label="Go to profile">
                      <img src={global.userAry['userPhoto']?global.userAry['userPhoto']:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"} onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"}} alt="Profile picture" title="Profile picture"/>
                      </a>
                      </div>
                  </div>
                  <div className="baby_name_title_disc B20_21 useName">
                  {global.userAry['userName']?global.userAry['userName']:''}     
                  </div>
                  
              </div> 
        </div>
        </div>
      </div>
      </div> 
      
   
  }
  </div> 

  );
};
